import styled from "styled-components";

// ---------------------------------------------------------------------------
// Shared accent tokens (mirror builderShellStyled)
// ---------------------------------------------------------------------------
const NAVY = "#005e9e";
const NAVY_LIGHT = "#e8f2fa";

// ---------------------------------------------------------------------------
// Layout wrappers
// ---------------------------------------------------------------------------

export const InspWrap = styled.div`
	padding: 14px;
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const EmptyHint = styled.div`
	font-size: 13px;
	color: #94a3b8;
	text-align: center;
	padding: 28px 10px;
	line-height: 1.6;
`;

// ---------------------------------------------------------------------------
// Section headings
// ---------------------------------------------------------------------------

export const SecHead = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	font-weight: 700;
	color: #1e293b;
`;

export const SecPill = styled.span`
	font-size: 10px;
	font-weight: 600;
	color: #64748b;
	background: #f1f5f9;
	border: 1px solid #e3e8ef;
	padding: 1px 7px;
	border-radius: 5px;
`;

export const SecSub = styled.div`
	font-size: 11px;
	color: #94a3b8;
	line-height: 1.5;
	margin-top: -6px;
`;

// ---------------------------------------------------------------------------
// Field wrapper
// ---------------------------------------------------------------------------

export const Field = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const FieldLabel = styled.label`
	font-size: 10px;
	font-weight: 700;
	color: #64748b;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const FieldVal = styled.span`
	font-size: 11px;
	font-weight: 600;
	color: #334155;
	background: #f1f5f9;
	border-radius: 5px;
	padding: 2px 7px;
`;

// ---------------------------------------------------------------------------
// Range input
// ---------------------------------------------------------------------------

export const RangeInput = styled.input`
	width: 100%;
	accent-color: ${NAVY};
`;

// ---------------------------------------------------------------------------
// Segmented control
// ---------------------------------------------------------------------------

export const SegRow = styled.div`
	display: flex;
	gap: 5px;
`;

interface SegItemProps {
	active?: boolean;
}

export const SegItem = styled.button<SegItemProps>`
	flex: 1;
	font-size: 12px;
	font-weight: 600;
	padding: 6px 5px;
	border: 1px solid ${({ active }) => (active ? NAVY : "#e3e8ef")};
	border-radius: 7px;
	background: ${({ active }) => (active ? NAVY_LIGHT : "#fff")};
	color: ${({ active }) => (active ? NAVY : "#334155")};
	cursor: pointer;
	transition: background 0.12s, border-color 0.12s, color 0.12s;

	&:hover {
		background: ${NAVY_LIGHT};
		border-color: ${NAVY};
		color: ${NAVY};
	}
`;

// ---------------------------------------------------------------------------
// Swatches
// ---------------------------------------------------------------------------

export const SwatchRow = styled.div`
	display: flex;
	gap: 7px;
	flex-wrap: wrap;
	align-items: center;
`;

interface SwatchProps {
	active?: boolean;
}

export const Swatch = styled.button<SwatchProps>`
	width: 26px;
	height: 26px;
	border-radius: 7px;
	border: ${({ active }) => (active ? `2px solid ${NAVY}` : "1px solid #e3e8ef")};
	cursor: pointer;
	padding: 0;
	transition: transform 0.1s;
	outline: ${({ active }) => (active ? `2px solid ${NAVY}` : "none")};
	outline-offset: 2px;

	&:hover {
		transform: scale(1.1);
	}
`;

export const SwatchPickWrap = styled.label`
	position: relative;
	overflow: hidden;
	width: 26px;
	height: 26px;
	border-radius: 7px;
	border: 1px solid #e3e8ef;
	cursor: pointer;
	background: conic-gradient(red, orange, yellow, lime, cyan, blue, magenta, red);
	flex-shrink: 0;
`;

export const SwatchColorInput = styled.input`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	border: none;
	padding: 0;
	cursor: pointer;
`;

// ---------------------------------------------------------------------------
// Select (font)
// ---------------------------------------------------------------------------

export const StyledSelect = styled.select`
	width: 100%;
	padding: 7px 9px;
	border: 1px solid #e3e8ef;
	border-radius: 8px;
	font-size: 13px;
	background: #fff;
	color: #1e293b;
`;

// ---------------------------------------------------------------------------
// Theme card wrapper
// ---------------------------------------------------------------------------

export const ThemeCard = styled.div`
	background: #f8fafc;
	border: 1px solid #e3e8ef;
	border-radius: 11px;
	padding: 13px;
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

// ---------------------------------------------------------------------------
// Contrast / brand warning
// ---------------------------------------------------------------------------

export const WarnBox = styled.div`
	font-size: 12px;
	color: #9a3412;
	background: #fff7ed;
	border: 1px solid #fed7aa;
	border-radius: 8px;
	padding: 9px 11px;
	line-height: 1.5;
`;
